// Landing comercial (helevas.com / helevas.com.co). No toca Firestore de inquilinos:
// solo el registro, que pasa por una Cloud Function.
document.getElementById('app').innerHTML =
  '<main style="font-family:var(--fuente);max-width:720px;margin:0 auto;padding:64px 24px">' +
  '<h1 style="color:var(--col-primary);font-size:32px;margin:0 0 12px">HELEVAS</h1>' +
  '<p style="color:var(--col-muted);font-size:15px">Cimientos del landing listos.</p>' +
  '</main>';
